import React from 'react'

import './styles.scss'
import { getStaticImage } from 'utils/statics'
import { lang } from 'utils/helpers'
import { getTitle, statusTypes } from './utils'

const SourceStatus = ({ status }) => {
  if (!statusTypes.includes(status)) return null

  return (
    <figure className='generated-responses-source-status' title={lang(getTitle(status))}>
      {status === 'uploaded' ? (
        <img src={getStaticImage('/icons/icon-check-circle-secondary.svg')} alt='Uploaded' />
      ) : null}
      {status === 'in_progress' ? (
        <img src={getStaticImage('/icons/icon-warning-gray-white.svg')} alt='In progress' />
      ) : null}
      {status === 'error' ? (
        <img src={getStaticImage('/icons/icon-warning-red.svg')} alt='Error' />
      ) : null}
      {status === 'processed' ? (
        <img src={getStaticImage('/icons/icon-check-circle-secondary.svg')} alt='Processed' />
      ) : null}
    </figure>
  )
}

export default SourceStatus
